import { EducationType, ResumeTabsType } from '../../../../../types/ResumeTypes';

import C from '../ViewerMode.module.scss';
import ResumeInfoPeriod from '../../../../common/ResumeInfoPeriod/index';
import { ConstantUtils } from '../../../../../utils/ConstantUtils';
import React from 'react';
import _ from 'lodash';

interface EducationViewerProps {
  educations: EducationType[];
  resumeTabs: ResumeTabsType;
}

const EducationViewer = (props: EducationViewerProps) => {
  const { educations, resumeTabs } = props;

  if (educations === undefined || educations.length === 0) {
    return null;
  }

  return (
    <>
      <section ref={resumeTabs[1].element} className={`${C.viewer_section} wrapper`}>
        <h4 className={`${C.section_title} h4`}>학력사항</h4>
        {educations?.map((education, index) => {
          return <EducationElementViewer education={education} key={`education-viewer-${index}`} />;
        })}
      </section>
      <hr />
      {/* {educations?.map((education, index) => {
        return <EducationElementViewer education={education} key={`education-viewer-${index}`} />;
      })} */}
    </>
  );
};

interface EducationElementViewerProps {
  education: EducationType;
}

const EducationElementViewer = (props: EducationElementViewerProps) => {
  const { education } = props;

  const isUniversity = ['EDU_5', 'EDU_6', 'EDU_4'].includes(education.level);

  return (
    <>
      <article className={`${C.common_box}`}>
        {/* 기간 */}
        <ResumeInfoPeriod
          text={_.isEmpty(education.endAt) ? '재학중' : '졸업'}
          startDate={education.startAt || ''}
          endDate={education.endAt || ''}
        />
        {/* 상세 내용 */}
        <div className={`${C.profile_text_wrap}`}>
          <div className={`${C.profile_text_line}`}>
            <div className={C.text_el_wrap}>
              <h2 className="h2">{education.name || ''}</h2>
              {isUniversity && (
                <>
                  <span className="divided-line" />
                  <h4 className="h4">{ConstantUtils.convertToEducation(education.level) || ''}</h4>
                  {education.majors?.map((major, index) => (
                    <React.Fragment key={`major-viewer-${index}`}>
                      <span className="divided-line" />
                      <h4 className="h4">{major.name}</h4>
                    </React.Fragment>
                  ))}
                </>
              )}
            </div>
          </div>
          {isUniversity && (
            <div className={C.profile_text_line}>
              <div className={C.text_el_wrap}>
                <h4 className="b1">학점</h4>
                <span className="divided-line" />
                <h4 className="b1">
                  {education.grade || '0'}/{education.standardOfGrade || '4.5'}
                </h4>
              </div>
            </div>
          )}
        </div>
      </article>
    </>
  );
};

export default EducationViewer;
